export const SET_ADD_NEW_PARTNER_OPENED = "partners/SET_ADD_NEW_PARTNER_OPENED";
export const SET_ACTIVE_PARTNER = "partners/SET_ACTIVE_PARTNER";
export const SET_PARTNERS = "partners/SET_PARTNERS";
export const SET_IS_HISTORY_OPENED = "partners/SET_IS_HISTORY_OPENED";

export interface Group {
    id: string;
    displayName: string;
}
export interface IPartner {
    id: string;
    name: string;
    tenantsAmount: number;
    usersAmount: number;
    aadGroupName: string;
}

export interface IActivePartner {
    id: string;
    name: string;
}

export interface INewPartner {
    name: string;
    aadGroupName: string;
}

export interface ICustomer {
    id: string;
    name: string;
    tenants: ITenant[];
}

export interface ITenant {
    id: string;
    name: string;
    moniker: string;
}

export interface IAadGroupUser {
    displayName: string;
    userPrincipalName: string;
}

export interface IPartnerCustomer extends ICustomer {
    partnerId: string;
}

export interface IPartnerDetails {
    id: string;
    name: string;
    aadGroupName: string;
    customers: IPartnerCustomer[];
    aadGroupUsers: IAadGroupUser[];
}

export interface PartnerHistory {
    partnerId: string;
    creator: string;
    creationDate: string;
}

export interface SetAddNewPartnerOpened {
    type: typeof SET_ADD_NEW_PARTNER_OPENED;
    isAddNewPartnerOpened: boolean;
}

export interface SetActivePartner {
    type: typeof SET_ACTIVE_PARTNER;
    activePartner: IActivePartner;
}

export interface SetPartners {
    type: typeof SET_PARTNERS;
    partners: IPartner[];
}

export interface SetIsHistoryOpened {
    type: typeof SET_IS_HISTORY_OPENED;
    isHistoryOpened: boolean;
}

export interface State {
    partners: IPartner[];
    activePartner: {
        name: string;
        id: string;
    };
    isAddNewPartnerOpened: boolean;
    isHistoryOpened: boolean;
}

export type Actions =
    | SetPartners
    | SetActivePartner
    | SetAddNewPartnerOpened
    | SetIsHistoryOpened;
